import {DTO} from '@/shared/base/dto';
import {ENDPOINT, METHOD} from '@/constants';
import {IDownloadStatus, IQueryRequest, IQueryLangRequest} from '@/types';

export class GetListRequestDTO extends DTO {
  public param: undefined;
  public url: string = ENDPOINT.REQUEST;
  public method = METHOD.GET;
  public body: unknown;
  public readonly responseClass: unknown;
  public query: IQueryRequest;
  constructor(query: IQueryRequest) {
    super();
    this.query = query;
  }
}
export class RequestOcrDTO extends DTO {
  public static url = ENDPOINT.REQUEST;
  public url = ENDPOINT.REQUEST;
  public method = METHOD.POST;
  public query: undefined;
  public param: undefined;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(public body: any) {
    super();
  }
}
export class ExportExcelOcrDTO extends DTO {
  public param: undefined;
  public url = ENDPOINT.EXPORT_EXCEL;
  public method = METHOD.GET;
  public body: unknown;
  public readonly responseClass: unknown;
  public query: IQueryRequest;
  constructor(query: IQueryRequest) {
    super();
    this.query = query;
    this.responseType = 'blob';
  }
}
export class ExportExcelDetailOcrDTO extends DTO {
  public param: {id: number} | undefined;
  public url = ENDPOINT.EXPORT_DETAIL_OCR;
  public method = METHOD.GET;
  public body: unknown;
  public readonly responseClass: unknown;
  public query: IQueryLangRequest;
  constructor(param: {id: number}, query: IQueryLangRequest) {
    super();
    this.responseType = 'blob';
    this.param = param;
    this.query = query;
  }
}
export class UpdateStatusDownloadDTO extends DTO {
  public param: {id: number} | undefined;
  public url = ENDPOINT.UPDATE_STATUS_OCR_LIST;
  public method = METHOD.PUT;
  public body: IDownloadStatus;
  public readonly responseClass: unknown;
  public query: undefined;
  constructor(param: {id: number}) {
    super();
    this.param = param;
    this.body = {
      downloadStatus: false,
    };
  }
}

export class GetResultReviewDTO extends DTO {
  public param: {id: number} | undefined;
  public url = ENDPOINT.GET_RESULT_REVIEW;
  public method = METHOD.GET;
  public body: unknown;

  public readonly responseClass: unknown;
  public query: undefined;
  constructor(param: {id: number}) {
    super();
    this.param = param;
  }
}

export class GetPdfReviewDTO extends DTO {
  public param: {id: number} | undefined;
  public url = ENDPOINT.GET_PDF_REVIEW;
  public method = METHOD.GET;
  public body: unknown;

  public readonly responseClass: unknown;
  public query: undefined;
  constructor(param: {id: number}) {
    super();
    this.param = param;
    this.responseType = 'arraybuffer';
  }
}

export class UpdateResultDocumentDTO extends DTO {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public body: any;
  public url: string = ENDPOINT.GET_RESULT_REVIEW;
  public method = METHOD.PUT;
  public param: {id: number | undefined};
  public query: undefined;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(param: {id: number | undefined}, body: any) {
    super();
    this.param = param;
    this.body = body;
  }
}

export class UploadMultipleImageDTO extends DTO {
  public static url = ENDPOINT.UPLOAD_MULTIPLE_IMAGE;
  public url = ENDPOINT.UPLOAD_MULTIPLE_IMAGE;
  public method = METHOD.POST;
  public query: undefined;
  public param: undefined;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(public body: any) {
    super();
  }
}

export class CancelRequestDTO extends DTO {
  public param: {id: number} | undefined;
  public url = ENDPOINT.CANCEL_REQUEST;
  public method = METHOD.PATCH;
  public body: undefined;
  public readonly responseClass: unknown;
  public query: undefined;
  constructor(param: {id: number}) {
    super();
    this.param = param;
  }
}

export class RetryRequestDTO extends DTO {
  public param: {id: number} | undefined;
  public url = ENDPOINT.RETRY_REQUEST;
  public method = METHOD.PATCH;
  public body: undefined;
  public readonly responseClass: unknown;
  public query: undefined;
  constructor(param: {id: number}) {
    super();
    this.param = param;
  }
}
